/* eslint-disable max-len */
import KasQuestion from 'images/coin-pages/questions/kas.svg'

import { ICoinPageData } from '../types'
import { blogCards, commonSlidesData } from '../commonPageData'

export const kasPage: ICoinPageData = {
  title: 'coin_575',
  description: 'coin_576',
  // description:
  //   'Get a Kaspa loan. Receive up to 90% of your Kaspa loan collateral in cash or crypto and continue holding. Borrow Kaspa instantly for an unlimited term and get extra funds in 15 minutes without selling your crypto.',
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Kaspa (KAS)' }) }}
    />
  ),
  questionsBlock: {
    image: KasQuestion,
    questions: [
      {
        title: 'coin_577',
        answer: 'coin_578',
      },
      {
        title: 'coin_579',
        answer: 'coin_580',
      },
      {
        title: 'coin_581',
        answer: 'coin_582',
      },
      {
        title: 'coin_583',
        answer: 'coin_584',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Kaspa (KAS)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_585',
        text: ['coin_587'],
      },
      {
        title: 'coin_586',
        text: ['coin_588'],
      },
    ],
    blogCards: [
      blogCards.borrowLikePro,
      blogCards.howCryptoAssetsSecured,
      blogCards.whatTypesOfCryptoLoansAreThereAndHowCanIProfitFromIt,
    ],
  },
}
